<template>
  <div>
    <!-- BEGIN FORM-->
    <form id="form_questions_create" class="form-horizontal col-xs-12 absolute-parlsey-errors">
        <div class="form-body col-xs-12">


          <div class="mt-element-ribbon col-xs-12" v-for="(question,index) in questions">
            <div class="ribbon ribbon-border-hor ribbon-clip ribbon-color-info uppercase">
              <div class="ribbon-sub ribbon-clip"></div> Question n°{{index+1}}
            </div>

            <a class="bt-actions" style="white-space: nowrap;" v-on:click="addQuestion(index)"><span aria-hidden="true" class="icon-plus"></span> Ajouter</a>

            <a class="text-danger bt-actions" style="white-space: nowrap;" v-on:click="removeQuestion(index)">
              <span aria-hidden="true" class="icon-close"></span> Supprimer
            </a>

            <a v-if="index < questions.length-1" class="text-info bt-actions" style="white-space: nowrap;" v-on:click="moveQuestion(index,index+2)"><span aria-hidden="true" class="icon-arrow-down"></span> Descendre</a>
            <a v-if="index != 0" class="text-info bt-actions" style="white-space: nowrap;" v-on:click="moveQuestion(index,index-1)"><span aria-hidden="true" class="icon-arrow-up"></span> Monter</a>


            <br><br>

            <div class="form-group form-md-line-input">
                <label class="col-md-3 control-label">Titre
                    <span class="required" aria-required="true">*</span>
                </label>
                <div class="col-lg-6 col-md-9">
                    <input type="text" class="form-control" placeholder="" v-model="question.title"  required>
                    <div class="form-control-focus"> </div>
                </div>
            </div>
            <div class="form-group form-md-line-input">
                <label class="col-md-3 control-label">Description
                    <!-- <span class="required" aria-required="true">*</span> -->
                </label>
                <div class="col-lg-6 col-md-9">
                    <textarea type="text" class="form-control" placeholder="" v-model="question.description"></textarea>
                    <div class="form-control-focus"></div>
                    <span class="help-block">La description apparaîtra en dessous du titre pour expliquer votre question si besoin.</span>
                </div>
            </div>
            <div class="form-group form-md-line-input">
                <label class="col-md-3 control-label">Type
                    <span class="required" aria-required="true">*</span>
                </label>
                <div class="col-lg-6 col-md-9">
                    <select type="text" class="form-control" v-model="question.type"  required>
                      <option value="text">Réponse ouverte</option>
                      <!-- <option value="textarea">Réponse longue</option> -->
                      <!-- <option value="select">Selection</option> -->
                      <option value="radio">Choix unique simple</option>
                      <option value="checkbox">Choix multiples simple</option>
                      <option value="checkbox_multiple">Choix multiples avec système d'imbrication à deux niveaux</option>
                      <option value="radio_multiple">Choix unique avec système d'imbrication à deux niveaux</option>
                      <!-- <option value="number">Nombre</option> -->
                      <!-- <option value="date">Date</option> -->
                      <option value="scale">Echelle de notation</option>
                    </select>
                </div>
            </div>
            <div class="form-group form-md-line-input" v-if="question.type == 'scale' || question.type == 'radio' || question.type == 'checkbox' || question.type == 'checkbox_multiple' || question.type == 'radio_multiple'">
                <label class="col-md-5 control-label">Couleur pour le choix 'ne se prononce pas'
                    <!-- <span class="required" aria-required="true">*</span> -->
                </label>
                <div class="col-md-3">
                  <div class="box-color" :style="{'background-color':question.color_no_response}" @click="showColorPicker(index)">
                    <input type="text" :id="'colorPicker'+index" class="form-control input-color hide" :data-index-question="index" :data-swatches="dataSwatches" value="">
                  </div>
                </div>
            </div>
            <div class="form-group form-md-line-input" v-if="question.type == 'number' || question.type == 'scale'">
                <label class="col-md-3 control-label">Valeur minimum
                    <span class="required" aria-required="true">*</span>
                </label>
                <div class="col-lg-6 col-md-9">
                  <input type="number" min="0" :max="question.max ? question.max : ''" @change="addColors(question)" class="form-control" v-model="question.min" required>
                  <div class="form-control-focus"> </div>
                </div>
            </div>
            <div class="form-group form-md-line-input" v-if="question.type == 'number' || question.type == 'scale'">
                <label class="col-md-3 control-label">Valeur maximum
                    <span class="required" aria-required="true">*</span>
                </label>
                <div class="col-lg-6 col-md-9">
                  <input type="number" :min="question.min ? question.min : 1" class="form-control" @change="addColors(question)" v-model="question.max" required>
                  <div class="form-control-focus"> </div>
                </div>
            </div>
            <div v-if="question.type == 'select' || question.type == 'radio' || question.type == 'checkbox' || question.type == 'checkbox_multiple' || question.type == 'radio_multiple'"  v-for="(data,index_data) in question.data">
                <div class="form-group form-md-line-input">
                  <label class="col-md-3 col-sm-2 col-xs-11 col-xs-offset-1 control-label">Choix n°{{index_data+1}}
                      <span class="required" aria-required="true">*</span>
                  </label>
                  <div class="col-lg-3 col-md-5 col-sm-5 col-xs-6 col-xs-offset-1 col-sm-offset-0">
                    <input type="text" class="form-control" v-model="data.name" required>
                    <div class="form-control-focus"> </div>
                  </div>
                  <div class="col-lg-1 col-md-1 col-sm-2 col-xs-2">
                    <div class="box-color" :style="{'background-color':data.color}" @click="showColorPicker(index,null,index_data)" data-toggle="tooltip" title="Couleur associé pour le graphique.">
                      <input type="text" :id="'colorPicker'+index+'-data-'+index_data" class="form-control input-color hide" :data-index-question="index" :data-index-data="index_data" :data-swatches="dataSwatches" value="">
                    </div>
                  </div>
                  <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2 mt-10">
                    <a style="white-space: nowrap;" class="text-danger" v-show="question.data.length > 1" v-on:click="question.data.splice(index_data,1)">
                      <span aria-hidden="true" class="icon-close"></span>
                    </a>
                  </div>
                  <div class="col-xs-11 col-md-7 text-right mt-20" v-if="index_data == question.data.length-1">
                    <a style="white-space: nowrap;" v-on:click="question.data.push({name:''})">
                      <span aria-hidden="true" class="icon-plus"></span> Ajouter</a>
                  </div>
                </div>
            </div>
            <div class="form-group form-md-line-input"  v-for="(choice,i) in question.data" v-if="question.type == 'checkbox_multiple' || question.type == 'radio_multiple'">
              <div class="col-xs-12 form-group form-md-line-input p-0 m-0">
                <label class="col-md-3 control-label">
                    Question imbriquée choix: {{choice.name}}
                </label>
                <div class="col-lg-6 col-md-9">
                  <a v-if="!choice.question" v-on:click="choice.question = {title:'',type:'',data:[],min:null,max:null,color_no_response:'#00b0f0',colors:[]};$forceUpdate()" class="btn"><span aria-hidden="true" class="icon-plus"></span> Ajouter</a>
                </div>
              </div>
              <div class="col-xs-12 mt-10" v-if="choice.question">
                <div class="col-xs-12 form-group form-md-line-input">
                  <label class="col-md-3 control-label">
                      Titre:
                      <span class="required" aria-required="true">*</span>
                  </label>
                  <div class="col-lg-6 col-md-9">
                    <input type="text" class="form-control" v-model="choice.question.title" required>
                    <div class="form-control-focus"> </div>
                  </div>
                </div>
                <div class="col-xs-12 form-group form-md-line-input">
                  <label class="col-md-3 control-label">
                      Description:
                      <!-- <span class="required" aria-required="true">*</span> -->
                  </label>
                  <div class="col-lg-6 col-md-9">
                    <input type="text" class="form-control" v-model="choice.question.description">
                    <div class="form-control-focus"> </div>
                  </div>
                </div>
                <div class="col-xs-12 form-group form-md-line-input">
                  <label class="col-md-3 control-label">
                      Type:
                      <span class="required" aria-required="true">*</span>
                  </label>
                  <div class="col-lg-6 col-md-9">
                    <select type="text" class="form-control" v-model="choice.question.type" v-on:change="addData(choice)" required>
                      <option value="text">Réponse ouverte</option>
                      <option value="radio">Choix unique simple</option>
                      <option value="checkbox">Choix multiples simple</option>
                      <option value="scale">Echelle de notation</option>
                    </select>
                  </div>
                </div>
                <div class="col-xs-12 form-group form-md-line-input" v-if="choice.question.type == 'scale' || choice.question.type == 'radio' || choice.question.type == 'checkbox' || choice.question.type == 'checkbox_multiple' || choice.question.type == 'radio_multiple'">
                    <label class="col-md-5 control-label">Couleur pour le choix 'ne se prononce pas'
                        <!-- <span class="required" aria-required="true">*</span> -->
                    </label>
                    <div class="col-md-3">
                      <div class="box-color" :style="{'background-color':choice.question.color_no_response}" @click="showColorPicker(index,null,null,null,i)">
                        <input type="text" :id="'colorPicker'+index+'-question-'+i" class="form-control input-color hide" :data-index-question="index" :data-index-question-two="i" :data-swatches="dataSwatches" value="">
                      </div>
                    </div>
                </div>
                <div class="col-xs-12 form-group form-md-line-input" v-if="choice.question.type == 'checkbox' || choice.question.type == 'radio'" v-for="(choice_data,di) in choice.question.data">
                  <div class="form-group form-md-line-input p-0 m-0">
                    <label class="col-md-3 col-sm-2 col-xs-11 col-xs-offset-1 control-label">Choix n°{{di+1}}
                        <span class="required" aria-required="true">*</span>
                    </label>
                    <div class="col-lg-3 col-md-5 col-sm-5 col-xs-6 col-xs-offset-1 col-sm-offset-0">
                      <input type="text" class="form-control" v-model="choice_data.name" required>
                      <div class="form-control-focus"> </div>
                    </div>
                    <div class="col-lg-1 col-md-1 col-sm-2 col-xs-2">
                      <div class="box-color" :style="{'background-color':choice_data.color}" @click="showColorPicker(index,null,i,di)" data-toggle="tooltip" title="Couleur associé pour le graphique.">
                        <input type="text" :id="'colorPicker'+index+'-data-'+i+'-data2-'+di" class="form-control input-color hide" :data-index-question="index" :data-index-data="i" :data-index-data-two="di" :data-swatches="dataSwatches" value="">
                      </div>
                    </div>
                    <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2 mt-10">
                      <a style="white-space: nowrap;" class="text-danger" v-show="choice.question.data.length > 1" v-on:click="choice.question.data.splice(di,1)">
                        <span aria-hidden="true" class="icon-close"></span>
                      </a>
                    </div>
                    <div class="col-xs-11 col-md-7 text-right mt-20" v-if="di == choice.question.data.length-1">
                      <a style="white-space: nowrap;" v-on:click="choice.question.data.push({name:''});forceUpdate()">
                        <span aria-hidden="true" class="icon-plus"></span> Ajouter</a>
                    </div>
                  </div>
                </div>
                <div class="col-xs-12 form-group form-md-line-input" v-if="choice.question.type == 'scale'">
                  <div class="form-group form-md-line-input">
                      <label class="col-md-3 control-label">Valeur minimum
                          <span class="required" aria-required="true">*</span>
                      </label>
                      <div class="col-lg-6 col-md-9">
                        <input type="number" min="0" :max="choice.question.max ? choice.question.max : ''" @change="addColors(choice.question)" class="form-control" v-model="choice.question.min" required>
                        <div class="form-control-focus"> </div>
                      </div>
                  </div>
                  <div class="form-group form-md-line-input">
                      <label class="col-md-3 control-label">Valeur maximum
                          <span class="required" aria-required="true">*</span>
                      </label>
                      <div class="col-lg-6 col-md-9">
                        <input type="number" :min="choice.question.min ? choice.question.min : 1" @change="addColors(choice.question)" class="form-control" v-model="choice.question.max" required>
                        <div class="form-control-focus"> </div>
                      </div>
                  </div>
                  <div class="form-group form-md-line-input" v-if="choice.question.type == 'scale'">
                      <label class="col-md-3 control-label">Couleurs associées
                          <!-- <span class="required" aria-required="true">*</span> -->
                      </label>
                      <div class="col-lg-6 col-md-9" v-if="choice.question.max && choice.question.min">
                        <div v-if="parseInt(choice.question.max)-parseInt(choice.question.min)+1 > 0">
                          <div v-for="color, index_data_color in choice.question.colors" class="box-color" :style="{'background-color':color}" @click="showColorPicker(index,index_data_color,i)">
                            {{index_data_color+parseInt(choice.question.min)}}
                            <input type="text" :id="'colorPicker'+index+'-data-'+i+'-'+index_data_color" class="form-control input-color hide" :data-index-question="index" :data-index-data="i" :data-index-color="index_data_color" :data-swatches="dataSwatches" value="">
                          </div>
                        </div>
                        <div v-else style="margin-top:5px;" class="text-danger">
                          Valeur invalide. La valeur maximum doit être supérieure à la valeur minimum.
                        </div>
                      </div>
                      <div class="col-lg-6 col-md-9" style="margin-top:5px;color:gray;" v-else>
                        Vous devez saisir les valeurs minimum et maximum.
                      </div>
                  </div>
                </div>
                <div class="col-xs-12">
                  <div class="col-md-3">
                  </div>
                  <div class="col-lg-6 col-md-9 p-0">
                    <a v-on:click="choice.question = null;forceUpdate()" class="p-0 btn text-danger"><span aria-hidden="true" class="icon-close"></span> Retirer</a>
                  </div>
                </div>
              </div>
            </div>
            <!-- <div class="form-group form-md-line-input" v-if="question.type == 'checkbox_multiple'">
              <label class="col-md-3 col-xs-offset-1 control-label">
                  Question imbriquée choix n°{{i}}
                  <span class="required" aria-required="true">*</span>
              </label>
              <div class="col-lg-3 col-md-6">
                <input type="text" class="form-control" required>
                <div class="form-control-focus"> </div>
              </div>
            </div> -->
            <!-- <div class="form-group form-md-line-input">
                <label class="col-md-3 control-label">La question dépend-t-elle d'une réponse à une précédente question ?
                    <span class="required" aria-required="true">*</span>
                </label>
                <div class="col-md-9">

                  <input data-parsley-excluded="true" type="checkbox" class="make-switch" data-on-text="OUI" data-off-text="NON" data-on-color="success" data-off-color="danger" :data-index="index" :checked="question.required_question_id">
                </div>
            </div> -->
            <!-- <div class="form-group form-md-line-input" v-if="switchs[index]">
                <label class="col-md-3 control-label">Question dépendante :
                    <span class="required" aria-required="true">*</span>
                </label>
                <div class="col-lg-6 col-md-9">
                  <select type="text" class="form-control" v-model="question.required_question_id" required v-on:change="forceUpdate()">
                    <option :value="q.id" v-if="i != index" v-for="(q,i) in questions">Question n°{{i+1}} - {{q.title}}</option>
                  </select>
                </div>
            </div> -->
            <!-- <div class="form-group form-md-line-input" v-if="switchs[index]">
                <label class="col-md-3 control-label">Valeur requise à la question dépendante :
                    <span class="required" aria-required="true">*</span>
                </label>
                <div class="col-lg-6 col-md-9">
                  <input type="text" class="form-control" placeholder="" v-model="question.required_question_value"  required>
                  <div class="form-control-focus"> </div>
                </div>
            </div> -->

            <div class="form-group form-md-line-input" v-if="question.type == 'scale'">
                <label class="col-md-3 control-label">Couleurs associées
                    <!-- <span class="required" aria-required="true">*</span> -->
                </label>
                <div class="col-lg-6 col-md-9" v-if="question.max && question.min">
                  <div v-if="parseInt(question.max)-parseInt(question.min)+1 > 0">
                    <div v-for="color, index_color in question.colors" class="box-color" :style="{'background-color':color}" @click="showColorPicker(index,index_color)">
                      {{index_color+parseInt(question.min)}}
                      <input type="text" :id="'colorPicker'+index+'-'+index_color" class="form-control input-color hide" :data-index-question="index" :data-index-color="index_color" :data-swatches="dataSwatches" value="">
                    </div>
                  </div>
                  <div v-else style="margin-top:5px;" class="text-danger">
                    Valeur invalide. La valeur maximum doit être supérieure à la valeur minimum.
                  </div>
                </div>
                <div class="col-lg-6 col-md-9" style="margin-top:5px;color:gray;" v-else>
                  Vous devez saisir les valeurs minimum et maximum.
                </div>
            </div>

            <hr v-if="index != questions.length-1" style="width:80%;margin:auto;border-style:dashed;position:relative;top:60px;border-color:gray;">

          </div>


          <div class="col-md-6 col-md-offset-3">
            <div v-if="questions.length == 0" class="note note-danger">
              <h4 class="block"> Avertissement</h4>
              <p> Votre questionnaire doit comporter au moins une question ! <br>
                  Cliquez sur le bouton en bas à droite <a v-on:click="addQuestion()">Ajouter une question</a>.
              </p>
            </div>
          </div>


          <div class="col-xs-12 text-right">
            <a style="white-space: nowrap;" v-on:click="addQuestion()"><span aria-hidden="true" class="icon-plus"></span> Ajouter une question</a>
          </div>

        </div>

    </form>
    <!-- END FORM-->
  </div>
</template>


<script>

  import quizzes from '../../requests/quizzes.js'
  import questions from '../../requests/questions.js'

  export default {
    props: ["quiz","show"],
    data(){
      return{
        dataSwatches:"#c00000|#ff0000|#ff7c80|#ffc000|#ffff00|#ccff66|#92d050|#00cc66|#00b050|#548235|#00b0f0",
        questions:[],
        switchs:[false],
        questionsToDelete:[]
      }
    },
    mounted:function(){
      this.init();
    },
    watch:{
      "quiz.questions":function(){
        this.init();
      }
    },
    methods:{
      showColorPicker(index,index_color,index_data,index_data2,index2){
        var parent = this;
        this.$nextTick(function(){
          $(".input-color").minicolors({
            swatches: $(".input-color").attr('data-swatches') ? $(".input-color").attr('data-swatches').split('|') : [],
            change: function(value, opacity) {
              if(this.getAttribute("data-index-data") != null && this.getAttribute("data-index-color") != null){
                parent.questions[this.getAttribute("data-index-question")].data[this.getAttribute("data-index-data")].question.colors[this.getAttribute("data-index-color")] = value;
              }
              else if(this.getAttribute("data-index-data") != null && this.getAttribute("data-index-data-two") != null){
                parent.questions[this.getAttribute("data-index-question")].data[this.getAttribute("data-index-data")].question.data[this.getAttribute("data-index-data-two")].color = value;
              }
              else if(this.getAttribute("data-index-data") != null){
                parent.questions[this.getAttribute("data-index-question")].data[this.getAttribute("data-index-data")].color = value;
              }
              else if(this.getAttribute("data-index-color") != null){
                parent.questions[this.getAttribute("data-index-question")].colors[this.getAttribute("data-index-color")] = value;
              }
              else if(this.getAttribute("data-index-question") != null && this.getAttribute("data-index-question-two")){
                parent.questions[this.getAttribute("data-index-question")].data[this.getAttribute("data-index-question-two")].question.color_no_response = value;
              }
              else if(this.getAttribute("data-index-question") != null){
                parent.questions[this.getAttribute("data-index-question")].color_no_response = value;
              }
              parent.$forceUpdate();
            }
          });

          this.$nextTick(function(){
            if(index_color != null && index_data != null){
              $($($("#colorPicker"+index+'-data-'+index_data+'-'+index_color)[0]).parent()[0].children[1]).mousedown();
            }
            else if(index_data != null && index_data2 != null){
              $($($("#colorPicker"+index+'-data-'+index_data+'-data2-'+index_data2)[0]).parent()[0].children[1]).mousedown();
            }
            else if(index_color != null){
              $($($("#colorPicker"+index+'-'+index_color)[0]).parent()[0].children[1]).mousedown();
            }
            else if(index_data != null){
              if(!this.questions[index].data[index_data].color){
                this.questions[index].data[index_data].color = "";
              }
              $($($("#colorPicker"+index+'-data-'+index_data)[0]).parent()[0].children[1]).mousedown();
            }
            else if(index != null && index2 != null){
              if(this.questions[index].data[index2].question && !this.questions[index].data[index2].question.color_no_response){
                this.questions[index].data[index2].question.color_no_response = "#00b0f0";
              }
              $($($("#colorPicker"+index+'-question-'+index2)[0]).parent()[0].children[1]).mousedown();
            }
            else if(index != null){
              $($($("#colorPicker"+index)[0]).parent()[0].children[1]).mousedown();
            }

          })
        })

      },
      addColors(question){
        var nb = parseInt(question.max)-parseInt(question.min)+1;
        if(nb > 0){
          if(!question.colors){
            question.colors = [];
          }
          for(var i=0;i<nb;i++){
            if(question.colors[i] == null){
              question.colors.push("");
            }
          }
          if(question.colors.length > nb){
            question.colors.splice(nb);
          }
        }
      },
      init(){
        this.reinit();
        if(this.quiz.questions.length > 0){
          this.questions = this.quiz.questions;
          for(var q=0;q<this.questions.length;q++){
            // if(this.questions[q].required_question_id){
            //   this.switchs[q] = true;
            // }
            // else{
            //   this.switchs[q] = false;
            // }
            if(!this.questions[q].data || this.questions[q].data.length <= 0){
              if(!this.questions[q].data){
                this.questions[q].data = [];
              }
              this.questions[q].data.push({name:"",question:null,color:''});
            }
          }
        }

        var parent = this;
        this.$nextTick(function () {
          $(".make-switch").bootstrapSwitch();
          this.listenerSwitch();
          $('[data-toggle="tooltip"]').tooltip();
        })
      },
      reinit(){
        this.questions = [{
          title:"",
          description:"",
          type:"",
          data:[
            {
              name:"",
              question:null,
              color:""
            }
          ],
          min:null,
          max:null,
          colors:[],
          color_no_response:"#00b0f0"
        }];
        // this.switchs = [false];
        this.questionsToDelete = [];

      },
      addData(choice){
        if(choice.question.type == 'checkbox' || choice.question.type == 'radio'){
          choice.question.data.push({name:'', color:''})
        }
        this.$forceUpdate();
        $('[data-toggle="tooltip"]').tooltip();
      },
      forceUpdate(){
        this.$forceUpdate();
      },
      listenerSwitch(){
        // var parent = this;
        // $('.make-switch').on('switchChange.bootstrapSwitch', function(event, state){
        //   var index = this.getAttribute("data-index");
        //   parent.switchs[index] = state;
        //   if(!state){
        //     parent.questions[index].required_question_id = "";
        //     parent.questions[index].required_question_value = "";
        //   }
        //   parent.$forceUpdate();
        // });
      },
      saveQuestions(exit){
        if(this.questions.length <= 0){
          toastr.error("Vous devez ajouter des questions à votre questionnaire !","ERREUR");
          return;
        }
        $('#form_questions_create').parsley().validate()
        if($("#form_questions_create").parsley().isValid()){

          var parent = this;
          // Si la question a un ID alors update sinon create.
          var questionsToCreate = [];
          var questionsToUpdate = [];
          for(var i=0;i<this.questions.length;i++){
            // for(var d=0;d<this.questions[i].data.length;d++){
            //   var val = this.questions[i].data[d].name.trim().toLowerCase();
            //   val = val.replace(/\s/g,'_'); // On remplace les espaces par _ ;
            //   this.questions[i].data[d]["value"] = val;
            // }

            // if(this.questions[i].required_question_value){
            //   var val = this.questions[i].required_question_value.trim().toLowerCase();
            //   val = val.replace(/\s/g,'_'); // On remplace les espaces par _ ;
            //   this.questions[i].required_question_value = val;
            // }

            this.questions[i]['order'] = i; // On rajoute son ordre dans la liste.
            if(this.questions[i].id){
              // Update chaque question. (Pb: On sait pas si elle a été modif. flood de requête possiblement inutile).
              questionsToUpdate.push(this.questions[i]);
            }else{
              questionsToCreate.push(this.questions[i]);
            }
          }

          var maxStep = questionsToCreate.length > 0 ? 1 : 0;
          maxStep += questionsToUpdate.length;
          maxStep += this.questionsToDelete.length;

          var val = 0;
          var errorsToUpdate = [];
          var errorsToDelete = [];
          var errorToCreate = false;

          var end = function(){
            val++;
            parent.$root.$emit('progressBar',true,0,maxStep,val,"Etape "+val+" sur "+maxStep);
            if(val == maxStep){

              var success = false;
              var msg = "";
              if(errorsToUpdate.length > 0){
                toastr.options.closeButton = true;
                if(errorsToUpdate.length == 1){
                  toastr.error(errorsToUpdate.length + " question n'a pas pu être mise à jour.","ERREUR");
                }
                else{
                  toastr.error(errorsToUpdate.length + " questions n'ont pas pu être mises à jour.","ERREUR");
                }
              }
              else{
                if((questionsToUpdate.length - errorsToUpdate.length) > 0){
                  success = true;
                  var questions_update = (questionsToUpdate.length - errorsToUpdate.length);
                  if(questions_update == 1){
                    msg += "1 question a été mise à jour.";
                  }
                  else{
                    msg += questions_update +" questions ont été mises à jour.";
                  }
                }
              }

              if(errorsToDelete.length > 0){
                toastr.options.closeButton = true;
                if(errorsToDelete.length == 1){
                  toastr.error(errorsToDelete.length + " question n'a pas pu être supprimée.","ERREUR");
                }
                else{
                  toastr.error(errorsToDelete.length + " questions n'ont pas pu être supprimées.","ERREUR");
                }
              }
              else{
                if((parent.questionsToDelete.length - errorsToDelete.length) > 0){
                  success = true;
                  var questions_delete = (parent.questionsToDelete.length - errorsToDelete.length);
                  msg += msg != "" ? "<br>" : "";
                  if(questions_delete == 1){
                    msg += "1 question a été supprimée.";
                  }
                  else{
                    msg += questions_delete +" questions ont été supprimées.";
                  }
                }
              }

              if(questionsToCreate.length > 0){
                if(errorToCreate){
                  toastr.options.closeButton = true;
                  if(questionsToCreate.length == 1){
                    toastr.error(questionsToCreate.length + " question n'a pas pu être créé.","ERREUR");
                  }
                  else{
                    toastr.error(questionsToCreate.length + " questions n'ont pas pu être créés.","ERREUR");
                  }
                }
                else{
                  success = true;
                  msg += msg != "" ? "<br>" : "";
                  if(questionsToCreate.length == 1){
                    msg += "1 question a été crée.";
                  }
                  else{
                    msg += questionsToCreate.length +" questions ont été crées.";
                  }
                }
              }

              parent.$root.$emit('progressBar',false);
              parent.reinit();

              if(success){
                toastr.options.closeButton = true;
                toastr.options.timeOut = 7000;
                toastr.success(msg);
                parent.getQuestions(parent.quiz.slug);
              }

              if(exit){
                parent.$router.push({name:"quizzes_list"});
              }
              else{
                parent.show.share = true;
              }

            }
          }

          this.$root.$emit('progressBar',true,0,maxStep,0,"Etape 0 sur "+maxStep);
          // MAJ des QUESTIONS EXISTANTES
          for(var u=0;u<questionsToUpdate.length;u++){
            questions.updateById(this,questionsToUpdate[u].id,questionsToUpdate[u],function(question,err){
              if(!question || err){
                errorsToUpdate.push(err);
              }
              end();
            })
          }


          // CREATION DES QUESTIONS
          if(questionsToCreate.length > 0){
            quizzes.createQuestions(this,this.quiz.slug,questionsToCreate,function(questions,err){
              if(!questions || err){
                errorToCreate = true;
              }
              end();
            })
          }

          // SUPPRESSION DES QUESTIONS qui ont été supprimées.
          for(var q=0;q<this.questionsToDelete.length;q++){
            quizzes.removeQuestionById(this,this.quiz.slug,this.questionsToDelete[q],function(err){
              if(err){
                errorsToDelete.push(err);
              }
              end();
            })
          }

        }
      },
      removeQuestion(index){
          console.log(index)
        // Si ID alors on sauvegarde l'id de la question à supprimer.
        if(this.questions[index].id){
          this.questionsToDelete.push(this.questions[index].id);
        }
        // this.switchs.splice(index,1);
        this.questions.splice(index,1);
      },
      addQuestion(index){
        index = index == undefined ? this.questions.length : index;
        this.questions.splice(index,0,{
          title:"",
          description:"",
          type:"",
          data:[
            {
              name:"",
              question:null,
              color:""
            }
          ],
          min:null,
          max:null,
          colors:[],
          color_no_response:'#00b0f0'
        });
        // this.switchs.push(false);
        this.$nextTick(function () {
          $(".make-switch").bootstrapSwitch();
          $('[data-toggle="tooltip"]').tooltip();
          this.listenerSwitch();
        })
      },
      getQuestions(quizSlug){
        // Récupérer les questions du questionnaire pour MAJ le quiz.questions correctement.
        var parent = this;
        var slug = quizSlug ? quizSlug : parent.$route.params.slug;
        quizzes.getQuestions(parent,quizSlug,function(questions,err){
          if(questions){
            parent.quiz.questions = questions;
            parent.$parent.forceUpdate();
          }
          else{
            toastr.error("Impossible de récupérer les questions du questionnaire.","ERREUR");
          }
          parent.$forceUpdate();
        })
      },
      moveQuestion(index,new_index){
        var questionToMove = this.questions[index];
        this.questions.splice(new_index,0,questionToMove);
        var old_index = new_index <= index ? index+1 : index;
        this.questions.splice(old_index,1);
      }
    },
    beforeRouteLeave (to, from, next) {
      // called when the route that renders this component is about to
      // be navigated away from.
      // has access to `this` component instance.

      // Réinit le quiz si on est sur la route quizzes_edit et qu'on click sur quizzes_create.
      this.reinit();
      next();
    }
  }
</script>
<style scoped>
  .ribbon{
    left:-60px!important;
  }

  .bt-actions{
    text-align: right;
    margin-top: 20px;
    background-color: white;
    padding-left:10px;
    float:right;
  }

  .box-color{
    padding-top:10px;
    padding-bottom: 10px;
    min-width: 35px;
    min-height: 41px;
    float: left;
    margin:5px;
    text-align: center;
    border:1px dashed gray;
    cursor:pointer;
  }


</style>



// WEBPACK FOOTER //
// create_questions.vue?9106aeda